import { ContactRows, SocialLinks, Logo, CardQR } from "@/features/cards/templates/parts";

// One locked composition; only the background variant (template_id) changes.
export function LockedCard({ identity: id, templateId, idPrefix = "card" }) {
  return (
    <div className="mwc" data-template={templateId}>
      <div className={`mwc-card mwl mwl-bg-${templateId}`}>
        <div className="mwl-head">
          <div className="mwl-brand">
            <Logo src={id.logoUrl} className="mwl-logo" alt={id.company || ""} />
            {id.company && <span className="mwl-wordmark">{id.company}</span>}
          </div>
          <span className="mwl-pill">Digital Business Card</span>
        </div>
        <div className="mwl-main">
          {id.fullName && <h2 className="mwl-name">{id.fullName}</h2>}
          {id.title && <p className="mwl-title">{id.title}</p>}
          <div className="mwl-rule" />
          {id.company && <p className="mwl-company">{id.company}</p>}
          <ContactRows identity={id} className="mwl-contacts" />
          <SocialLinks links={id.links} className="mwl-social" labels={false} />
        </div>
        {id.photoUrl && <img src={id.photoUrl} alt={id.fullName || ""} className="mwl-photo" />}
        <CardQR value={id.qrValue} className="mwl-qr" fg="#0B0B0C" testId={`${idPrefix}-qr`} />
      </div>
    </div>
  );
}
